import React from 'react';
import type { Step } from '../content/home';
import Reveal from '../primitives/Reveal';

interface HowItWorksProps {
  steps: Step[];
}

/** The four steps as hairline-divided rows: numeral, title, one paragraph. */
export default function HowItWorks({ steps }: HowItWorksProps) {
  return (
    <Reveal>
      <ol className="mk-steps">
        {steps.map((step) => (
          <li key={step.id} className="mk-step">
            <span className="mk-step__num t-details">{step.numeral}</span>
            <div>
              <h3 className="mk-step__title">{step.title}</h3>
              <p className="mk-step__body t-body">{step.body}</p>
            </div>
          </li>
        ))}
      </ol>
    </Reveal>
  );
}
